import React from "react";

function Section2() {
  return (
    <section className="csrd-section-2-container">
      <div className="csrd-section-2-inner-container">
        <div className="left-section-2">
          <div className="left-section-2-inner-container">
            <img
              src={require("../../../../assets/Solution/csrd/csrd_dc.svg")}
              className="img2"
              alt="csrd data collection"
            />

            <div className="datatrack-grey-circle-left"></div>
          </div>
        </div>
        <div className="right-section-2">
          <div className="right-section-2-inner-container">
            <h2 className="section-2-heading">CSRD Data Collection</h2>
            <p className="section-2-description">
              <div>
                Supports both quantitative and qualitative data, ensuring full compliance with ESRS
                disclosure requirements
              </div>
              <div>
                Detects and utilizes previously tracked ESG data for CSRD reporting, eliminating
                redundant data entry.
              </div>
              <div>
                Auto-populates qualitative disclosures using AI assistance, reducing manual effort
                while maintaining accuracy.
              </div>
            </p>
            <div className="dot-grid-2"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section2;
